import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-target": "#course-trainnning-statistics",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, " Course Summary (Monthly Breakdown) ")
  ])
], -1)
const _hoisted_3 = {
  id: "course-trainnning-statistics",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body p-6" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_13 = { class: "col-md-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Course", -1)
const _hoisted_15 = { class: "col-md-2 mt-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_18 = { class: "position-relative" }
const _hoisted_19 = {
  id: "courseTReport",
  class: "collapse show"
}
const _hoisted_20 = { class: "collapse show" }
const _hoisted_21 = {
  class: "card-body p-0 mt-7",
  style: {"overflow":"scroll"}
}
const _hoisted_22 = { class: "row w-100 mb-2" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 my-auto" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "m-0" }, "Course Summary (Monthly Breakdown)")
], -1)
const _hoisted_24 = {
  class: "col-md-6 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = {
  class: "table table-borderless",
  style: {"border":"1.5px solid black"}
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("thead", { style: {"border-left":"1.5px solid black"} }, [
  /*#__PURE__*/_createElementVNode("tr", {
    class: "fw-bolder bg-light text-black",
    style: {"border-bottom":"1px solid #23ce10"}
  }, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      rowspan: "2"
    }, " SL "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      rowspan: "2"
    }, " Date Ranges "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      rowspan: "2"
    }, " No of Batches "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      colspan: "2"
    }, " Enrollment "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      colspan: "2"
    }, " Assessment "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      colspan: "2"
    }, " Certification "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"},
      colspan: "3"
    }, " Job Placement ")
  ]),
  /*#__PURE__*/_createElementVNode("tr", {
    class: "fw-bolder bg-light text-black",
    style: {"border-bottom":"1px solid #23ce10"}
  }, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, "Total "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " Female"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, "Total "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " Female"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, "Total "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " Female"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, "Total "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " Female"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "align-middle border border-gray-400 sticky-header",
      style: {"text-align":"center"}
    }, " Eligible For Bill ")
  ])
], -1)
const _hoisted_33 = { style: {} }
const _hoisted_34 = { class: "fw-bolder border border-gray-400 text-center" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  class: "text-center"
}, "Total", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _hoisted_10,
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.tranche_id,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tranche_id) = $event)),
                  options: _ctx.optionsTranche,
                  mode: "tags",
                  "clear-on-select": false,
                  placeholder: "Select Training Partner",
                  "close-on-select": false,
                  searchable: true,
                  "create-option": true
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select Partner",
                  modelValue: _ctx.entity_id,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.entity_id) = $event)),
                  filterable: "",
                  style: {"width":"100%"},
                  onChange: this.getCourseList
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.association, (data) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: data.id,
                        label: data.entity_short_name,
                        value: data.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("[" + _toDisplayString(data?.entity_short_name) + "]-" + _toDisplayString(data.entity_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_el_select, {
                  class: "form-select-solid",
                  "collapse-tags": "",
                  placeholder: "Select Course",
                  modelValue: _ctx.course_info_id,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.course_info_id) = $event)),
                  filterable: "",
                  style: {"width":"100%"},
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showBtnStatus()))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courses, (course) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: course.id,
                        label: course.course_name,
                        value: course.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(course.course_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                (_ctx.showBtn)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.courseWiseBreakDownReport())),
                      type: "button",
                      class: "btn btn-success mt-6 p-3",
                      style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                    }, [
                      _createTextVNode(" Search "),
                      _hoisted_16
                    ]))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.courseWiseBreakDownReport())),
                      type: "button",
                      disabled: "",
                      class: "btn btn-success mt-6 p-3",
                      style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                    }, [
                      _createTextVNode(" Search "),
                      _hoisted_17
                    ]))
              ])
            ]),
            (_ctx.showCourseSummary == true)
              ? (_openBlock(), _createElementBlock("div", { key: _ctx.componentKey }, [
                  _createElementVNode("div", _hoisted_18, [
                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _hoisted_23,
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                                title: "Download Xlse",
                                "data-v-54b12dc8": "",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.exportTrainee()))
                              }, _hoisted_26),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                                title: "Download PDF",
                                "data-v-54b12dc8": "",
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.downloadPdf()))
                              }, _hoisted_28),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                                title: "Print",
                                "data-v-54b12dc8": "",
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.printPdf()))
                              }, _hoisted_30)
                            ])
                          ]),
                          _createElementVNode("table", _hoisted_31, [
                            _hoisted_32,
                            _createElementVNode("tbody", _hoisted_33, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.courseWiseBreakDown, (data, inx) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: inx,
                                  class: "border border-gray-400 text-center"
                                }, [
                                  _createElementVNode("td", null, _toDisplayString(data?.sl), 1),
                                  _createElementVNode("td", null, _toDisplayString(data?.start_date) + " to " + _toDisplayString(data?.end_date), 1),
                                  _createElementVNode("td", null, _toDisplayString(data?.batch_count), 1),
                                  _createElementVNode("td", null, _toDisplayString(data?.enrollment), 1),
                                  _createElementVNode("td", null, _toDisplayString(data?.female_enrollment), 1),
                                  _createElementVNode("td", null, _toDisplayString(data?.assesment), 1),
                                  _createElementVNode("td", null, _toDisplayString(data?.female_assesment), 1),
                                  _createElementVNode("td", null, _toDisplayString(data?.certification), 1),
                                  _createElementVNode("td", null, _toDisplayString(data?.female_certification), 1),
                                  _createElementVNode("td", null, _toDisplayString(data?.job_placement), 1),
                                  _createElementVNode("td", null, _toDisplayString(data?.female_job_placement), 1),
                                  _createElementVNode("td", null, _toDisplayString(data?.job_placement_3m), 1)
                                ]))
                              }), 128)),
                              _createElementVNode("tr", _hoisted_34, [
                                _hoisted_35,
                                _createElementVNode("td", null, _toDisplayString(this.totalbatch), 1),
                                _createElementVNode("td", null, _toDisplayString(this.totalenrollment), 1),
                                _createElementVNode("td", null, _toDisplayString(this.totalfemale_enrollment), 1),
                                _createElementVNode("td", null, _toDisplayString(this.totalassesment), 1),
                                _createElementVNode("td", null, _toDisplayString(this.totalfemale_assesment), 1),
                                _createElementVNode("td", null, _toDisplayString(this.totalcertification), 1),
                                _createElementVNode("td", null, _toDisplayString(this.totalfemale_certification), 1),
                                _createElementVNode("td", null, _toDisplayString(this.totaljob_placement), 1),
                                _createElementVNode("td", null, _toDisplayString(this.totalfemale_job_placement), 1),
                                _createElementVNode("td", null, _toDisplayString(this.totaljob_placement_3m), 1)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])), [
                      [_directive_loading, _ctx.load]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])), [
      [_directive_loading, _ctx.load]
    ])
  ]))
}